<template>
    <div>
        <router-link class="btn btn-sm btn-outline-secondary mb-1"
                     :to="view">
            View
        </router-link>
        <router-link class="btn btn-sm btn-outline-secondary mb-1"
                     :to="edit">
            Edit
        </router-link>
    </div>
</template>

<script>
  export default {
    props: {
      view: {
        type: Object
      },
      edit: {
        type: Object
      }
    },
    data() {
      return {}
    }
  }
</script>

<style scoped>
    .btn-outline-secondary {
        min-width: unset;
    }
</style>



// WEBPACK FOOTER //
// src/components/TableRowActions.vue